export enum CsSpecialist {
    // TODO: Replace this with a User relation that leverages Rampart groups
    Riza = "Riza",
    Alliza = "Alliza",
    Louella = "Louella",
    Chelsey = "Chelsey",
}
